import React from "react";
import "./Switch.scss";
export type labelPosition = "left" | "right";
export interface Props {
  switchMainClass?: any;
  switchId?: any;
  switchValue?: any;
  onChange?: any;
  switchLabel: string;
  switchClass?: string;
  switchlabelClass?: string;
  checked?: boolean;
  labelPosition?: labelPosition;
  switchOnText?: string;
  switchOffText?: string;
  name?:string
}
const Switch = ({
  switchMainClass,
  switchId,
  onChange,
  switchLabel,
  switchClass,
  switchlabelClass,
  checked,
  labelPosition = "left",
  switchValue,
  switchOnText,
  switchOffText,
  name
}: Props) => {
  const handleToggle = () => {
    onChange(!checked);
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLSpanElement>) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      onChange(!checked);
    }
  };
  return (
    <div
      className={`mfg-switch${switchMainClass ? " " + switchMainClass : ""}`}
      id={switchId}
    >
      <label
        className={`switchLabel${switchlabelClass ? " " + switchlabelClass : ""
          }${checked ? " checked" : ""} ${labelPosition}`}
        htmlFor={switchLabel.split(" ").join("").substring(0, 8)}
        role="switch"
        aria-checked={checked}
        onKeyDown={handleKeyDown}
        tabIndex={0}
      >
        <span>{switchLabel}</span>
        <div className="switchView" data-content={checked ?  switchOnText ? switchOnText : '' : switchOffText ? switchOffText : ''}></div>
      </label>
      <div className={`switchInput${switchClass ? " " + switchClass : ""}`}>
        <input
          type="checkbox"
          id={switchLabel.split(" ").join("").substring(0, 8)}
          checked={checked}
          onChange={handleToggle}
          value={switchValue}
          name={name}
        />
      </div>
    </div>
  );
};

export default Switch;
